import lodash from 'lodash'
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { generateRedux } from '../../../1stlog-ui/src/components/InfinityTable/Redux'
import { getIsGO } from '../../../1stlog-ui/src/utils/getIsGO'
import OrderList from '../../components/AuftragOrderList'
import { Statistics } from './Statistics'

export const redux = generateRedux({
  id: 'containers/OrderList/',
  url: '/api/orderlisting',
  initialState: {
    sortableColumns: ['created_at', 'sla', 'pickupTimeFrom'],
    includedFilters: {
      useDeliveryAddress: true,
      usePickupAddress: true,
    },
  },
  initialFilters: {
    sort: [
      {
        field: ['created_at'],
        direction: 'desc',
      },
    ],
    filter: [
      {
        field: 'date',
        value: {
          startDate: moment().subtract(30, 'days').startOf('day').toISOString(),
          endDate: moment().endOf('day').toISOString(),
        },
      },
    ],
  },

  sagas: [],
})

const connectRedux = connect(
  createStructuredSelector({
    ...redux.structuredSelector,
    // additional selectors here
  }),
  {
    ...redux.actions,
  },
)

const OrdersList = (props) => {
  const showStatistics = getIsGO()

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
      }}
    >
      <OrderList
        orderHref="order"
        {...props}
        customHeaderComponent={
          showStatistics && (
            <Statistics
              setFilter={props.setFilter}
              currentFilter={lodash.get(props.filterClean, 'filter')}
              applyFilter={props.applyFilter}
            />
          )
        }
      />
    </div>
  )
}

export default connectRedux(OrdersList)
